module.exports = __webpack_public_path__ + "img/小程序-active.23f1fd86.svg";